export const CART_CALL_PAGES_NEEDED = ['OrderOKView']
export const COREMEDIA_CONTENT = 'CoreMediaContentDisplay'
export const DELIVERY_DETAILS_REDESIGN_VIEW = 'DeliveryDetailsRedesignView'
export const DELIVERY_DETAILS_VIEW = 'DeliveryDetailsView'
export const FLUID_PCP = 'FluidRemixProductDisplayView'
export const GUEST_ORDER_ITEM_DETAILS_VIEW = 'GuestOrderItemDetailsView'
export const HOME_PAGE = 'GenericHomePageLayoutView'
export const MY_ADDRESSBOOK_VIEW = 'MyAddressbookView'
export const MY_DETAILS_VIEW = 'MyDetailsView'
export const MY_ORDERS_VIEW = 'MyOrdersView'
export const ORDER_OK_VIEW = 'OrderOKView'
export const PAYMENT_DETAILS_VIEW = 'PaymentDetailsView'
export const PAYMENT_REDESIGN_DETAILS_VIEW = 'PaymentRedesignDetailsView'
export const PDP_DISPLAY = 'ProductPage'
export const PDP_DISPLAY_VIEW = 'GenericProductPageLayoutView'
export const RB_CATEGORY_DISPLAY_VIEW = 'RBCategoryDisplayView'
export const RAYBAN_SEARCH_DISPLAY_VIEW = 'RaybanSearchDisplayView'
export const SEARCH_DISPLAY_PATHNAME = '/SearchDisplay'
export const SHOP_CART = 'ShopCart'
export const SHOPCART_DISPLAY = 'ShopCartDisplay'
export const SHOPCART_DISPLAY_VIEW = 'ShopCartDisplayView'
export const STATIC_PAGE_VIEW = 'StaticPageView'
export const THANK_YOU_PAGE_VIEW = 'ThankYouPageView'
export const VIEW_ORDERS = 'ViewOrders'
export const WISHLIST_VIEW = 'WishListView'
